// const jumappProd = "https://ipa-utilities.ktbst.co.th/ktbst/v1/services/authen/jumpapp";
// const saxo = "https://onepeace-service.ktbst.co.th/onepeace-saxo-api/api/v1/";

// const jumappDev = "https://test-api-unicorn.ktbst.co.th:3401/ktbst/v1/services/authen/jumpapp";
// const masterDev = "https://onepeace-service.ktbst.co.th/onepeace-saxo-api/api/v1/master";

// const saxoDev = "https://dev-onepeace-service.ktbst.co.th/onepeace-saxo-api/api/v1/";

const env: any = (envObj) => {
  const env = envObj.REACT_APP_DEPLOY_MENT;
  console.log("env", env);
  if (env === "production" || env === "master")
    return {
      baseApi: "https://onepeace-service.daol.co.th/otp-gateway-api/",
      ekycApi: "https://ekyc.daolsecurities.co.th/verify-ekyc?ekycToken=",
      classifyApi: "https://ekyc.daolsecurities.co.th/classify-customer?",
      ndidInvApi: "https://oa.daolinvestment.co.th/ndid-offline/home?",
      ndidSecApi: "https://oa.daolsecurities.co.th/ndid-offline/home?",
      reviewSuitKycInvApi:
        "https://oa.daolinvestment.co.th/review-suit-kyc/home?",
      secKycCode: envObj.REACT_APP_OTP_SEC_VENDER_CODE_KYC,
      secNDIDCode: envObj.REACT_APP_OTP_SEC_VENDER_CODE_NDID,
      imKycCode: envObj.REACT_APP_OTP_IM_VENDER_CODE_KYC,
      imNDIDCode: envObj.REACT_APP_OTP_IM_VENDER_CODE_NDID,
    };
  if (env === "develop" || env === "development" || env === "test")
    return {
      // baseApi: "http://localhost:8080/otp-gateway-api",
      baseApi: "https://dev-onepeace-service.daol.co.th/otp-gateway-api/",
      
      ekycApi: "https://dev-ekyc.daolsecurities.co.th/verify-ekyc?ekycToken=",
      classifyApi: "https://dev-ekyc.daolsecurities.co.th/classify-customer?",
      ndidInvApi: "https://dev-oa.daolinvestment.co.th/ndid-offline/home?",
      ndidSecApi: "https://dev-oa.daolsecurities.co.th/ndid-offline/home?",
      reviewSuitKycInvApi:
        "https://dev-oa.daolinvestment.co.th/review-suit-kyc/home?",
      secKycCode: envObj.REACT_APP_OTP_SEC_VENDER_CODE_KYC,
      secNDIDCode: envObj.REACT_APP_OTP_SEC_VENDER_CODE_NDID,
      imKycCode: envObj.REACT_APP_OTP_IM_VENDER_CODE_KYC,
      imNDIDCode: envObj.REACT_APP_OTP_IM_VENDER_CODE_NDID,
      // jumapp: jumappDev,
      // master: masterDev,
      // saxo: saxoDev,
    };
};
export default env(process.env);
